import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Card from '../../atoms/Card/Card';
import InputControl from '../../atoms/InputControl/InputControl';
import Grid from '../../atoms/Grid/Grid';
import './LoginPage.scss';
import Button from '../../atoms/Button/Button';
import { attemptLoginAction } from '../../../actions';

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { isLoggedIn, authLoading, lastAttemptFailed } = useSelector(state => state.auth);

  const dispatch = useDispatch();
  const history = useHistory();
  const loginAttempt = () => {
    if (!authLoading) {
      dispatch(attemptLoginAction(username, password));
    }
  };
  useEffect(() => {
    if (isLoggedIn) {
      history.push('/home');
    }
  }, [isLoggedIn]);
  return (
    <div className="login-page-container">
      <div className="card-container">
        <h3>Login into VMIC</h3>
        <Card title="Enter your credentials down below">
          <Grid>
            <div className="col-md-6">
              <img src="/images/login-artwork.webp" alt="login artwork" />
            </div>
            <div className="col-md-6">
              {lastAttemptFailed && (
                <small style={{ color: 'red' }}>Username/Password were incorrect</small>
              )}
              <InputControl
                label="Username/Email"
                onValueChanged={value => setUsername(value)}
                placeholder="Username or Email"
              />
              <InputControl
                label="Password"
                type="password"
                onValueChanged={value => setPassword(value)}
                placeholder="Password"
              />
              <Button label="Login" onInvoked={() => loginAttempt()} isLoading={authLoading} />
            </div>
          </Grid>
        </Card>
      </div>
    </div>
  );
};

export default LoginPage;
